import dayjs from "dayjs";

export interface IDateCollect {
    weekday: string;
    dayOfMonth: number;
    isoDate: string;
}

export const getMonthDaysForToday = () => {
    const startDate = dayjs().add(-30, 'd');
    const endDate = dayjs().add(40, 'd');
    let sevenCollect: IDateCollect[] = []
    const days: IDateCollect[][] = [];
    let adjustedStartDate = startDate.clone();
    while (adjustedStartDate.day() !== 0) {
        adjustedStartDate = adjustedStartDate.subtract(1, 'day');
    }
    let adjustedEndDate = endDate.clone();
    while (adjustedEndDate.day() !== 6) {
        adjustedEndDate = adjustedEndDate.add(1, 'day');
    }
    for (let date = adjustedStartDate; !date.isAfter(adjustedEndDate, 'd'); date = date.add(1, 'day')) {
        sevenCollect.push({
            weekday: date.format('ddd'),
            dayOfMonth: date.date(),
            isoDate: date.format("YYYY-MM-DD")
        });
        if (sevenCollect.length === 7) {
            days.push(sevenCollect);
            sevenCollect = []
        }
    }
    return days;
};

export const toSelectableDate = (value: string | null) => {
    if (!value) return null;

    const parsed = dayjs(value);
    if (!parsed.isValid()) return null;

    const formatted = parsed.format("YYYY-MM-DD");
    return getMonthDaysForToday().flat().some((day) => day.isoDate === formatted) ? formatted : null;
};

export const getWeekPage = (date: string) => {
    const weeks = getMonthDaysForToday();
    const selected = weeks.findIndex((week) => week.some((day) => day.isoDate === date));
    if (selected !== -1) return selected;

    const today = dayjs().format("YYYY-MM-DD");
    return Math.max(weeks.findIndex((week) => week.some((day) => day.isoDate === today)), 0);
};
